<template>
  <div class="col-12">
    <Toast />
    <Message
      v-for="msg of messages"
      :severity="msg.severity"
      :key="msg.content"
      >{{ msg.content }}</Message
    >

    <Message
      v-for="msg of messagesDistribuicao"
      :severity="msg.severity"
      :key="msg.content"
      >{{ msg.content }}</Message
    >

    <CardProcesso :processo="processo" />

    <Panel header="Informações aos candidatos">
      <p align="justify" v-for="linha in informacoesLiberacao" :key="linha">{{ linha }}</p>
      <br>
      <Divider />
      <br>
      <label class="font-bold">Entre em contato com a DIPROJ em caso de inconsistência nas informações a serem apresentadas aos candidatos</label>
    </Panel>

    <Panel v-if="temProcessos" header="Liberação do cartão de confirmação" >
      <div>
        <Button class="mr-6 mb-2 " label="Efetuar liberação" type="submit" style="width: 200px"
                @click="liberarCartao()" :disabled="!podeLiberarCartao">
        </Button>
      </div>
    </Panel>

    <lista-logs :lista.sync="listaLogs" label="Operações de Liberação de Cartão" :toggleable="false"/>

  </div>
</template>

<script>
import http from "@/http";
import { tratamentoDeErros } from "@/tratamentoDeErros";
import LocalProvaService from "../../service/LocalProvaService";
import ProcessoService from "../../service/ProcessoService";
import InscricaoService from "../../service/InscricaoService";
import LogService from "../../service/LogService";
import CardProcesso from "../../components/CardProcesso.vue";
import Divider from 'primevue/divider';
import ListaLogs from "../../components/log/ListaLogs.vue";

export default {
  mixins: [tratamentoDeErros],

  components: { CardProcesso, Divider, ListaLogs },

  data() {
    return {
      selectedArea: null,
      token: this.$store.state.token,
      habilitaInscricoes: false,
      cadastroEscolaDialog: false,
      temProcessos: false,
      messages: [],
      messagesDistribuicao: [],
      messagesCadastroLocal: [],
      expandedRows: [],
      aguardeDialog: false,
      processo: {
        id: null,
        nome: "",
        datHoraInicioInscricao: "",
        datHoraFimInscricao: "",
        coeficienteMinimo: null,
        areas: [],
      },
      inscricoes: [],
      perfil: "",
      // localProva: null,
      informacoesLiberacao: null,
      distribuicoes: [],
      distribuicaoConcluida: false,
      processoService: null,
      logService: null,
      podeLiberarCartao: false,
      listaLogs:[],
    };
  },
  localProvaService: null,
  salaService: null,
  qtCandidatos: 0,
  created() {
    this.localProvaService = new LocalProvaService();
    this.processoService = new ProcessoService();
    this.inscricaoService = new InscricaoService();
    this.processoService = new ProcessoService();
    this.logService = new LogService();
  },
  mounted() {
    this.processo = this.processoSelecionado;
    this.getProcessoAtivo();
    this.processoService.getInformacaoLiberacao()
        .then((data) => this.informacoesLiberacao = data);
  },
  watch: {
  	processoSelecionado() {
      this.processo = this.processoSelecionado;
      this.getProcessoAtivo();
  	}
  },
  computed: {
    processoSelecionado: {
      get() {
        return this.$store.state.processoSelecionado;
      },
    }
  },
  methods: {
    alterar() {
      this.messagesCadastroLocal = [];
      this.cadastroEscolaDialog = true;
    },

    hideDialog() {
      this.messagesCadastroLocal = [];
      this.cadastroEscolaDialog = false;
    },

    getProcessoAtivo() {
      this.processoService.getProcesso(this.processoSelecionado.id)
        .then((resposta) => {
          this.processo = resposta;
          this.processo.datHoraFimInscricao = this.$formatarDataHoraBR(this.processo.datHoraFimInscricao);
          this.processo.datHoraInicioInscricao = this.$formatarDataHoraBR(this.processo.datHoraInicioInscricao);
          this.temProcessos = true;
          this.podeLiberarCartao = this.processo.estadoSelecao.podeLiberarCartao;
          this.getLogs(this.processo.id);
        })
        .catch(() => {});
    },

    getLogs(selecaoId) {
      this.logService.listarLogs(selecaoId, 'LIBERAR_CARTAO')
        .then((data) => {
          this.listaLogs = data;
        });
    },

    getArea(sala) {
      return sala.inscricoesEstagioDto && sala.inscricoesEstagioDto.length > 0
        ? sala.inscricoesEstagioDto[0].nomeArea
        : "Sala não utilizada";
    },

    collapsedLocalProva() {
      return this.localProva != null && this.localProva.id != null
        ? true
        : false;
    },

    headerPanelLocalProva() {
      return this.localProva != null && this.localProva.id != null
        ? "Local da prova: " + this.localProva.nome
        : "Cadastre o local da prova";
    },

    formatarDataBR(dataUS) {
      return new Date(dataUS).toLocaleString();
    },

    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.inscricoes.length; i++) {
        if (this.inscricoes[i].id.selecaoEstagio.id === id) {
          index = i;
          break;
        }
      }
      return index;
    },

    downloadParaAssinar(tituloArquivo) {
      this.inscricaoService.exportarParaAssinar(
        this.processo.id,
        tituloArquivo
      );
    },

    liberarCartao() {
      if (!this.podeLiberarCartao) {
        this.messagesDistribuicao = "Não é possível liberar cartão de confirmação. Verifique a situação do processo de seleção.";
      }

      this.aguardeDialog = true;
      this.messagesDistribuicao = [];
      this.processoService
        .liberarCartao(this.processo, this.$store.state.username)
        .then(() => {
          this.getLogs(this.processo.id);
          this.$toast.add({
            severity: "success",
            summary: "Successo",
            detail: "O cartão de confirmação foi liberado, agora os candidatos podem acessá-lo",
            life: 5000,
          });
        })
        .catch((erro) => {
          console.log("erro: ", erro.data);
          this.messagesDistribuicao = this.getMessagesError(erro);
          this.aguardeDialog = false;
        });
    },

    onRowExpand(event) {
      this.inscricoes = [];
      this.aguardeDialog = true;
      if (event.data.id) {
        http
          .get(`inscricao/sala/${event.data.id}`)
          .then((resposta) => {
            this.inscricoes = resposta.data;
            this.aguardeDialog = false;
          })
          .catch((erro) => {
            this.messages = this.getMessagesError(erro);
            this.aguardeDialog = false;
          });
      }
    },
  },
};
</script>

<style scoped>
.aguarde {
  width: 130px;
  height: 130px;
  text-align: center;
}
</style>
